import { useContext, useState } from "react";
import { Context } from "../../../context/context";
import { Button, Input } from "@mui/material";
import axios from "axios";

import "./UploadExcel.scss";
import { BASE_API_URL } from "../../../utils/api-url";

export default function UploadExcel() {
  const [buttonDisabled, setButtonDisabled] = useState(false);
  const [file, setFile] = useState("");
  const { sidebar } = useContext(Context);
  const accessToken = localStorage.getItem("token");

  const handleFile = (e) => {
    setFile(e.target.files[0]);
  };

  const handleClick = async (e) => {
    e.preventDefault();
    setButtonDisabled(true);

    const formData = new FormData();
    formData.append("file", file);
    try {
      await axios.post(`${BASE_API_URL}/customers/upload`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${accessToken}`,
        },
      });

      alert("Tabela atualizada com sucesso.");
    } catch (error) {
      alert("Algo deu errado. Tente novamente mais tarde.");
    }
  };

  return (
    <>
      <main className={sidebar ? "container" : "container-full"}>
        <h1>Upload Excel</h1>
        <div className="file-container">
          <Input type="file" onChange={handleFile} />
          {file && (
            <Button
              disabled={buttonDisabled}
              onClick={handleClick}
              variant="contained"
            >
              Enviar
            </Button>
          )}
          <p>
            Esta operação pode demorar alguns minutos. Por favor aguarde
            concluir.
          </p>
        </div>
      </main>
    </>
  );
}
